import { render, staticRenderFns } from "./RekapPerMapelUjianHasilTPA.vue?vue&type=template&id=06d1f4a1"
import script from "./RekapPerMapelUjianHasilTPA.vue?vue&type=script&lang=js"
export * from "./RekapPerMapelUjianHasilTPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports